import React from "react";
import { kFormatter } from "@/utils";

interface StatItemProps {
  icon: React.ReactNode;
  label: string;
  value: number | null | undefined;
}

export function StatItem({ icon, label, value }: StatItemProps) {
  return (
    <div className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-white border border-slate-100 shadow-sm">
      <div className="text-slate-400 shrink-0">{icon}</div>
      <div className="flex flex-col min-w-0">
        <span className="text-xs font-bold text-slate-400 uppercase tracking-tight truncate leading-tight">
          {label}
        </span>
        <span className="text-sm font-bold text-slate-700 leading-tight">
          {value !== null && value !== undefined ? kFormatter(value) : "-"}
        </span>
      </div>
    </div>
  );
}
